import React from "react";

import { Route, Routes } from "react-router-dom";

import AllInitiatives from "./initiatives.all";
import InitiativeOptIn from "./initiatives.opt";
import PendingInitiativeRequest from "./initiatives.pending";
import CreateInitiative from "./initiatives.add";
import InitiativeApprovedReferral from "./initiatives.approved.referral";
import InitiativePendingReferrals from "./initiatives.pending.referral";
import InitiativeRejectedReferrals from "./initiative.rejected.referral";
import ViewInitiativeReferral from "./initiative.view.referral";
import ViewOrganizations from "./initiative.view.organizations";

const InitiativePage = () => {
  return (
    <>
      <Routes>
        <Route element={<InitiativeOptIn />} path="opt" />

        <Route element={<PendingInitiativeRequest />} path="pending" />

        <Route element={<CreateInitiative />} path="add" />

        <Route
          element={<InitiativePendingReferrals />}
          path=":initiativeId/pending-referrals"
        />

        <Route
          element={<InitiativeApprovedReferral />}
          path=":initiativeId/approved-referrals"
        />

        <Route
          element={<InitiativeRejectedReferrals />}
          path=":initiativeId/rejected-referrals"
        />

        <Route
          element={<ViewInitiativeReferral />}
          path=":initiativeId/view-referral/:referralId"
        />

        <Route
          element={<ViewOrganizations />}
          path=":initiativeId/view-organizations"
        />

        <Route element={<AllInitiatives />} path="" />

        <Route element={<AllInitiatives />} path="all" />
      </Routes>
    </>
  );
};
export default InitiativePage;
